import { Box, Button, FormControl, MenuItem, Select, Stack, Tooltip, Typography, Link } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectWorldCupResult, simWorldCupResultAgainAsync, simWorldCupResultAsync } from "./WorldCupResultSlice";
import { fetchTeamsAsync, selectTeam } from "./TeamSlice";
import React from "react";

export default function SimWorldCupHeader() {
    const result = useSelector(selectWorldCupResult);
    const teams = useSelector(selectTeam);
    const [year, setYear] = React.useState(2026);
    const dispatch = useDispatch();
    return <Box>
        <Typography fontSize="1.8em" margin="8px" variant="h1">
            {result.year + " FIFA World Cup"}
        </Typography>
        <Typography fontSize="12.8px" margin="8px">simulated by Sim World Cup</Typography>
        <Stack direction="row" spacing={1} margin="8px">
            <FormControl size="small">
                <Select
                    value={year}
                    onChange={(e) => {
                        setYear(e.target.value);
                        dispatch(fetchTeamsAsync({ year: e.target.value }));
                        dispatch(simWorldCupResultAsync({ year: e.target.value }));
                    }}
                    disabled={result.loading || teams.loading}
                >
                    {[2026, 2022, 2018, 2014, 2010, 2006, 2002, 1998, 1994, 1990, 1986]
                        .map(y => <MenuItem value={y} key={y}>{y}</MenuItem>)}
                </Select>
            </FormControl>
            <Tooltip title={year < 2026 ? "Reset to actual results" : "Simulate draw and all matches again"}>
                <span>
                    <Button
                        variant="contained"
                        onClick={() => dispatch(simWorldCupResultAsync({ year: year }))}
                        disabled={result.loading || teams.loading}
                        sx={{ height: "100%" }}
                    >
                        {year < 2026 ? "Reset" : "Sim"}
                    </Button>
                </span>
            </Tooltip>
            {year < 2026 && <Tooltip title="Simulate all matches again">
                <span>
                    <Button
                        variant="contained"
                        onClick={() => dispatch(simWorldCupResultAgainAsync({ year: year, draw: result.draw, ratings: result.ratings }))}
                        disabled={result.loading || teams.loading}
                        sx={{ height: "100%" }}
                    >
                        Sim
                    </Button>
                </span>
            </Tooltip>}
        </Stack>
        <Typography margin="8px">
            Try{" "}
            <Link
                href="https://simworldcup.vercel.app"
                target="_blank"
                rel="noopener noreferrer"
            >
                Sim World Cup 2026
            </Link>
            {" "}to simulate the 2026 World Cup with the official draw.
        </Typography>
    </Box>;
}